// extracted by css-extract-rspack-plugin
export default {"cls1":"CreateSocialItem-cls1_Uc2","cls2":"CreateSocialItem-cls2_S7E CreateSocialItem-cls1_Uc2","spaced":"CreateSocialItem-spaced_KXP"};